import TripleLayout from "./TripleLayout";
export default TripleLayout;


// WEBPACK FOOTER //
// ./src/TripleLayout/index.js